import UserRoleMap from '@/components/Common/UserRoleMap';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import UserEditionForm from '@/components/Users/UserEditionForm';

export default {
  name: 'UserData',
  components: {
    UserRoleMap,
    ShDividerLine,
    UserEditionForm,
  },
  props: {
    userUuid: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: () => ({
        login: 'login',
        email: 'email@email.com',
        name: 'Name',
        last_name: 'LastName',
        avatar: '/static/img/test-avatar.png',
        role: 'user',
      }),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    showEditionModal() {
      this.$emit('showEditionModal');
    },
  },
};
